import { Grid, TextField, Typography } from '@material-ui/core';
import React from 'react';
import resumeData from '../../Utils/resumeData';
import CustomButton from '../Button/Button';

const Contact = () => {
    return (
        <div>
<Grid container className="section">
    {/* contact form  */}
    <Grid item xs={12} lg={7} className="contact_left">
        <Grid container >
                <Grid item className="sectionTitle mb_30" >
                            <span></span>
                        <h6  className="sectiontitle_text " >Contact With Me</h6>
                </Grid>
                {/* Contact form  */}
                <Grid item xs={12}>
                    <Grid container spacing={3} >
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth name="name" label="Name" />
                        </Grid>
                        <Grid item xs={12} sm={6}spacing={2} >
                            <TextField fullWidth name="Email" label="Email" />
                        </Grid>
                        <Grid item xs={12}  >
                            <TextField fullWidth name="Massage" label="Massage" multiline rows={4} />
                        </Grid>
                        <Grid item xs={12}  className="pb_10"  >
                            <CustomButton text='submit' />
                        </Grid>
                    </Grid>
                </Grid>
        </Grid>
    </Grid>
{/* Contact Information  */}
    <Grid item xs={12} lg={5} className="contact_right">
        <Grid container className="">
            <Grid item className="sectionTitle mb_30" >
                            <span></span>
                       <h6  className="sectiontitle_text " >Contact Information</h6>
            </Grid>

            
            <Grid item xs={12} >
                <Grid container spacing={2}>

                    <Grid item  xs={12}>
                        <Typography className="contactItem">
                                <span>Address: </span>{resumeData.address}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography className="contactItem">
                                <span>Phone: </span>{resumeData.phone}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography className="contactItem">
                                <span>Email: </span>{resumeData.Email}
                        </Typography>
                    </Grid>
{/* 
                    <Grid item>
                        <Typography className="contact Item">
                                <span>Address: </span>{resumeData.address}
                        </Typography>
                    </Grid> */}

                 

                    
                </Grid>
            </Grid>
            
            <Grid item xs={12}>
                <Grid container className="contact_social">
                 
                  {
                         Object.keys(resumeData.socile).map(key => (
                            <Grid item className="social_icon_container">
                                <a  className="social_icon" href={resumeData.socile[key].link}>{resumeData.socile[key].icon}</a>
                            </Grid>

                        ))
                    }
                 
                </Grid>
            </Grid>

        </Grid>
        
    </Grid>
</Grid>
        </div>
    );
};

export default Contact;